module.exports = __webpack_public_path__ + "static/media/8-light-modes-face.a92e941c.png";